let passport = {
    // 
    login(){
        if(location.host.includes('bpm3-sit-usa.platanus.com')){
            return 'https://sso-sit-usa.platanus.com/public/login?requestUrl='
        }else if(location.host.includes('bpm3-dev.platanus.com') || location.host.includes('localhost')){
            return 'https://sso-dev.platanus.com/public/login?requestUrl='
        }else{
            return 'https://sso-usa.platanus.com/public/login?requestUrl='
        }
      },
    loginout(){
        if(location.host.includes('bpm3-sit-usa.platanus.com')){
            return 'https://sso-sit-usa.platanus.com/cas/logout?loginType=mixLogin&redirectUrl='
        }else if(location.host.includes('bpm3-dev.platanus.com') || location.host.includes('localhost')){
            return 'https://sso-dev.platanus.com/cas/logout?loginType=mixLogin&redirectUrl='
        }else{
            return 'https://sso-usa.platanus.com/cas/logout?loginType=mixLogin&redirectUrl='
        }
    }
}

export default passport


// WEBPACK FOOTER //
// ./src/assets/js/passport.js